import React from 'react';
import PropTypes from 'prop-types';
import { formatPercentageValue, formatToThousands } from '../../helpers/numberFormatter';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import APTable from '../common/APTable';
import './InstrumentSelectorPopupComponent.css';
var InstrumentSelectorPopupComponent = function InstrumentSelectorPopupComponent(props, context) {
  var onRowClick = props.onRowClick,
    level1 = props.level1,
    instruments = props.instruments,
    fetching = props.fetching,
    selectedRow = props.selectedRow,
    customClass = props.customClass,
    showFullNameInstrument = props.showFullNameInstrument;
  var baseClasses = getBEMClasses('instrument-selector-popup', customClass);
  var columns = [{
    header: context.t('Coin'),
    classModifier: 'coin',
    cell: function cell(instrument) {
      return showFullNameInstrument ? context.t(instrument.Product1FullName + ' / ' + instrument.Product2FullName) : instrument.Symbol;
    }
  }, {
    header: context.t('Price'),
    cell: function cell(instrument) {
      return instrument.lastTrade;
    }
  }, {
    header: context.t('24hr Chg'),
    cell: function cell(instrument) {
      return instrument.Rolling24HrPxChangePercent;
    }
  }, {
    header: context.t('Volume'),
    cell: function cell(instrument) {
      return instrument.Rolling24HrVolume;
    }
  }];
  var instrumentsRow = instruments.map(function (instrument) {
    var level1Data = level1[instrument.InstrumentId];
    return Object.assign({}, instrument, {
      lastTrade: level1Data && level1Data.LastTradedPx.toFixed(2),
      Rolling24HrPxChangePercent: level1Data && React.createElement('span', {
        className: baseClasses(level1Data.Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative')
      }, (level1Data.Rolling24HrPxChangePercent > 0 ? '+' : '') + formatPercentageValue(level1Data.Rolling24HrPxChangePercent)),
      Rolling24HrVolume: level1Data && formatToThousands(level1Data.Rolling24HrVolume)
    });
  });
  return React.createElement(APTable, {
    fetching: fetching,
    columns: columns,
    rows: instrumentsRow,
    baseClass: baseClasses,
    onRowClicked: function onRowClicked(instrument) {
      return onRowClick(instrument);
    },
    selectedRow: selectedRow,
    empty: context.t('No coin is available')
  });
};
InstrumentSelectorPopupComponent.propTypes = {
  level1: PropTypes.object.isRequired,
  onRowClick: PropTypes.func.isRequired,
  instruments: PropTypes.array.isRequired,
  fetching: PropTypes.bool.isRequired,
  selectedRow: PropTypes.object.isRequired
};
InstrumentSelectorPopupComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default InstrumentSelectorPopupComponent;